module.exports = __webpack_public_path__ + "img/achievement-course10.6844294f.png";